// extracted by mini-css-extract-plugin
export var notificationHost = "_hx-0";